export enum NfStatus {
  Awaiting = 'AWAITING',
  Processing = 'PROCESSING',
  Verified = 'VERIFIED',
  Rejected = 'REJECTED',
}
